import { FormFieldComponent } from './form-field.component';
import { InputDirective } from './input.directive';
import { LabelDirective } from './label.directive';

export { FormFieldComponent } from './form-field.component';
export { InputDirective } from './input.directive';
export { LabelDirective } from './label.directive';

export const InputModule = [FormFieldComponent, InputDirective, LabelDirective];
